import Reveal from "../components/Reveal";

const STEPS = [
  { n: "01", title: "Create your workspace", body: "Sign up and name your organization. That's your desk." },
  { n: "02", title: "Add your clients", body: "Import from a spreadsheet or add them one at a time — takes seconds either way." },
  { n: "03", title: "Connect your calendar", body: "Link Google Calendar or Outlook so bookings and events stay in sync automatically." },
  { n: "04", title: "Start working", body: "Send intake, book calls, deliver documents, invoice. All in the same place." },
];

export default function SimpleFromDayOne() {
  return (
    <section data-testid="simple-day-one" className="py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl mb-14">
          <h2 className="font-display font-extrabold text-[32px] sm:text-[44px] leading-[1.08] tracking-[-0.02em] text-[#1A2A3A] mb-4">
            Simple from day one.
          </h2>
          <p className="text-[16px] text-[#57534E] leading-relaxed">
            No 60-minute setup call. No implementation package. If you can send
            an email, you can run your VA business inside ClientDesk VA.
          </p>
        </Reveal>

        <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 70}>
              <li className="p-6 rounded-2xl bg-[#FAF7F2] border border-[#E8E2D9] h-full">
                <div className="font-display font-extrabold text-[28px] text-[#E8712C] tracking-[-0.02em] mb-3">
                  {s.n}
                </div>
                <h3 className="font-display font-bold text-[17px] text-[#1A2A3A] tracking-[-0.01em] mb-2">
                  {s.title}
                </h3>
                <p className="text-[14px] text-[#57534E] leading-relaxed">{s.body}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
